import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { modalContextValue } from "config/init/providers/ModalsProvider";
import { ModalKey } from "containers/Modals/modals";
import { ModalMetaInput, setModal } from "store/actions/modal";

type ModalMetaPayload = Partial<ModalMetaInput> & Record<string, unknown>;

export const useModal = (
  cb: Record<string, (...args: any[]) => void> = {},
  meta: ModalMetaPayload = {}
) => {
  const dispatch = useDispatch();

  return useCallback(
    (modalId: ModalKey, data?: Record<string, unknown>) => {
      const payload = { ...meta, ...data };

      modalContextValue.callbacks = cb;

      dispatch(setModal(modalId, payload));
    },
    [cb, dispatch, meta]
  );
};
